var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"smvp-viewer"},[_c('div',{staticClass:"profile",on:{"click":function($event){return _vm.onViewerClick()}}},[_c('profile',{attrs:{"user-id":_vm.pid,"user-name":_vm.userName,"subtitle":_vm.subtitle,"no-subtitle":!(_vm.subtitle.length)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }